var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.666656C5.10666 0.666656 0.333328 1.33332 0.333328 5.99999V18.6667C0.333328 21.24 2.42666 23.3333 4.99999 23.3333L3.46666 24.8667C3.05333 25.28 3.34666 26 3.94666 26H18.0667C18.6667 26 18.96 25.28 18.5333 24.8667L17 23.3333C19.5733 23.3333 21.6667 21.24 21.6667 18.6667V5.99999C21.6667 1.33332 16.8933 0.666656 11 0.666656ZM4.99999 20.6667C3.89333 20.6667 2.99999 19.7733 2.99999 18.6667C2.99999 17.56 3.89333 16.6667 4.99999 16.6667C6.10666 16.6667 6.99999 17.56 6.99999 18.6667C6.99999 19.7733 6.10666 20.6667 4.99999 20.6667ZM9.66666 12.6667H2.99999V5.99999H9.66666V12.6667ZM17 20.6667C15.8933 20.6667 15 19.7733 15 18.6667C15 17.56 15.8933 16.6667 17 16.6667C18.1067 16.6667 19 17.56 19 18.6667C19 19.7733 18.1067 20.6667 17 20.6667ZM19 12.6667H12.3333V5.99999H19V12.6667Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.7c4bbfd3665fbfaafcddb88395aaef63.svg";
export { ForwardRef as ReactComponent };